export const coursesHistorySx = {
    dialogPaper: {
        width: '400px',
        maxWidth: '90%',
        borderRadius: 3,
        p: 2,
        backgroundColor: '#fff',
    },
    dialogTitle: { fontWeight: 'bold' },
    dialogContentBox: { py: 1 },
    dialogActions: { justifyContent: 'flex-end' },
    closeButton: { borderRadius: 2 },
    table: { minWidth: 650 },
    tableHeadCell: { fontSize: 18, fontWeight: 'bold' },
    tableHeadCellCourse: { fontSize: 18, fontWeight: 'bold', py: 2, minWidth: "300px" },
    tableHeadCellPrice: { fontSize: 18, fontWeight: 'bold', minWidth: '150px' },
    tableHeadCellPayment: { fontSize: 18, fontWeight: 'bold', minWidth: '170px' },
    tableRowCell: { fontSize: 16, fontWeight: '600' },
    tableRowCellTimeDate: { fontSize: 16, fontWeight: 600, minWidth:"150px", py: 2 },
    courseBox: { display: 'flex', alignItems: 'center', gap: 1.5, minWidth: 0 },
    iconBox: { display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, width: 24, height: 24 },
    courseTitle: {
        textDecoration: 'none',
        cursor: 'pointer',
        fontWeight: 600,
        fontSize: 16,
        textTransform: 'capitalize',
        whiteSpace: 'nowrap',
        overflow: "hidden",
        textOverflow: "ellipsis",
        flexGrow: 1,
        minWidth: 0
    }
};
